module.exports = __webpack_public_path__ + "img/5473841147f184ad659ddc641bb4620b.f9dcf7b5.jpg";